// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3ta34","addWidgetButton":"Header_addWidgetButton__3cWAc","dashboardTabs":"Header_dashboardTabs__2bgNr","active":"Header_active__Y7DsF"};